export const RentInCompanies = [
  { value: "", label: "Select owner" },
  { value: "C1 Transportation", label: "C1 Transportation" },
  { value: "Fox C Group", label: "Fox C Group" },
  {
    value: "C1 Freight",
    label: "C1 Freight",
  },
  { value: "Rent out", label: "Rent out" },
  { value: "Rent in", label: "Rent in" },
  { value: "C1 Truck Rental & Leasing", label: "C1 Truck Rental & Leasing" },
  {
    value: "C1 Trailer Rental & Leasing",
    label: "C1 Trailer Rental & Leasing",
  },
];
